import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__grid">
        <section className="footer-brand">
          <h2>
            Designed To Fit.
            <br />
            Made To Last.
          </h2>
          <p>
            nartvmora designs considered denim and wardrobe staples with
            longevity at their core.
          </p>
          <Link to="/shop" className="text-link">
            Shop all
          </Link>
        </section>

        <details className="footer-links" open>
          <summary>Explore</summary>
          <Link to="/about">About us</Link>
          <Link to="/shop?sort=newest">New arrivals</Link>
          <Link to="/shop?sale=true">Sale policy</Link>
          <Link to="/terms">Terms of use</Link>
        </details>
        <details className="footer-links" open>
          <summary>Support</summary>
          <Link to="/fit-guide">Fit guide</Link>
          <Link to="/shipping">Shipping & returns</Link>
          <Link to="/contact">Contact us</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/cookies">Cookies</Link>
          <Link to="/faqs">FAQs</Link>
        </details>
        <details className="footer-links" open>
          <summary>Connect</summary>
          <p>east@nartvmora.site</p>
        </details>
      </div>
      <div className="site-footer__bottom">
        <span>
          © {new Date().getFullYear()} nartvmora ·{" "}
          <a href="mailto:east@nartvmora.site">east@nartvmora.site</a>
        </span>
        <div className="payment-methods" aria-label="Supported payment methods">
          <span>Visa</span><span>Mastercard</span><span>American Express</span><span>UnionPay</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
